import React from 'react';
import { useStore } from '../../context/StoreContext';

export default function Filters() {
  const { filters, setFilters, clearFilters } = useStore();

  const handleGender = (value) => {
    setFilters(prev => {
      const current = prev.gender;
      const updated = current.includes(value) 
        ? current.filter(g => g !== value)
        : [...current, value];
      return { ...prev, gender: updated };
    });
  };

  const handleCategory = (cat) => {
    setFilters(prev => {
      const current = prev.cat;
      const updated = current.includes(cat)
        ? current.filter(c => c !== cat)
        : [...current, cat];
      return { ...prev, cat: updated };
    });
  };

  const formatPrice = (n) => '₹' + n.toLocaleString('en-IN');

  return (
    <div className="lg:w-[280px] lg:shrink-0">
      <div className="lg:sticky lg:top-[88px]">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-bold text-lg">Filters</h3>
          <button onClick={clearFilters} className="text-sm font-semibold text-indigo-600 hover:underline">Clear All</button>
        </div>
        <div className="rounded-[24px] border border-slate-200 bg-white divide-y divide-slate-200">
          <div className="p-4">
            <h4 className="font-semibold text-sm mb-3">Gender</h4>
            <div className="flex flex-wrap gap-2">
              {['Men', 'Women', 'Unisex'].map(g => (
                <button
                  key={g}
                  onClick={() => handleGender(g)}
                  className={`px-3 py-1.5 rounded-full border text-sm transition ${
                    filters.gender.includes(g) ? 'bg-slate-900 text-white border-slate-900' : ''
                  }`}
                >
                  {g}
                </button>
              ))}
            </div>
          </div>
          <div className="p-4">
            <h4 className="font-semibold text-sm mb-3">Category</h4>
            <div className="space-y-2 text-sm">
              {['T-Shirts', 'Shirts', 'Jeans', 'Dresses', 'Sneakers', 'Jackets'].map(cat => (
                <label key={cat} className="flex items-center gap-2">
                  <input 
                    type="checkbox" 
                    className="accent-indigo-600"
                    checked={filters.cat.includes(cat)}
                    onChange={() => handleCategory(cat)}
                  />
                  {cat}
                </label>
              ))}
            </div>
          </div>
          <div className="p-4">
            <h4 className="font-semibold text-sm mb-3">Price</h4>
            <input 
              type="range" 
              min="299" 
              max="9999" 
              value={filters.price}
              onChange={(e) => setFilters(prev => ({ ...prev, price: +e.target.value }))}
              className="w-full accent-indigo-600"
            />
            <div className="flex justify-between text-xs text-slate-500 mt-1">
              <span>₹299</span>
              <span>{formatPrice(filters.price)}</span>
            </div>
          </div>
          <div className="p-4">
            <h4 className="font-semibold text-sm mb-3">Discount</h4>
            <div className="space-y-2 text-sm">
              {[30, 50, 70].map(d => (
                <label key={d} className="flex items-center gap-2">
                  <input 
                    type="radio" 
                    name="discount"
                    className="accent-indigo-600"
                    checked={filters.discount === d}
                    onChange={() => setFilters(prev => ({ ...prev, discount: d }))}
                  />
                  {d}% & above
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}